import { render, staticRenderFns } from "./MaterialVariant.vue?vue&type=template&id=57491f41"
import script from "./MaterialVariant.vue?vue&type=script&lang=js"
export * from "./MaterialVariant.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariant.vue?vue&type=style&index=0&id=57491f41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports